<template>
  <div class="casino-group-container">
    <template v-if="!specialGroupType">
      <div class="group-header">
        <h2 v-if="group.groupName" class="group-name">{{group.groupName}}</h2>
        <div v-if="showHideSeeAll" class="see-all"><router-link :to="{ name: 'casino-page', params: { slug: group.slug }}">{{$t('Casino.See.All')}}</router-link></div>
      </div>
      <div v-if="group.groupId" :data-gid="group.groupId" class="slider-container" :id="'slider-container-' + group.groupId">
        <casino-slider @showHideSeeAll="updateSeeAllStatus" :group="setGroupSliderItemLimit(group)" :gamesByGroup="filterGamesInfoDataByGroup(group.gameIds)"></casino-slider>
      </div>
    </template>
    <template v-if="specialGroupType">
      <component :is="specialGroupType" :group="group" :groupRender="true"></component>
    </template>
  </div>
</template>

<script>
import CasinoGameGroup from '@/components/igaming/partials/casinoGameGroup.vue'
import CasinoSlider from '@/components/igaming/partials/casinoSlider.vue'
import CasinoMarketingJackpots from '@/components/igaming/partials/casinoMarketingJackpots.vue'
import CasinoTopGames from '@/components/igaming/partials/casinoTopGames.vue'
import Casino from '@/components/mixins/Casino'

export default {
  name: 'casinoGroup',
  props: ['group', 'gamesWithInfoData'],
  mixins: [
    Casino
  ],
  components: {
    CasinoGameGroup,
    CasinoSlider,
    CasinoMarketingJackpots,
    CasinoTopGames
  },
  data () {
    return {
      specialGroupType: undefined,
      showHideSeeAll: true
    }
  },
  computed: {},
  methods: {
    updateSeeAllStatus (value) {
      this.showHideSeeAll = value
    }
  },
  mounted () {
    this.checkIsSpecialGroupType(this.group.type, this.group.groupId)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/igaming/partials/casinoGroup.vue